import { render, staticRenderFns } from "./UserOpinion.vue?vue&type=template&id=48d19988&scoped=true&"
import script from "./UserOpinion.vue?vue&type=script&lang=js&"
export * from "./UserOpinion.vue?vue&type=script&lang=js&"
import style0 from "./UserOpinion.vue?vue&type=style&index=0&id=48d19988&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d19988",
  null
  
)

export default component.exports